var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTedxMau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214.015,
    height: 47.821,
    viewBox: "0 0 214.015 47.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 397"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 246",
    d: "M2.9 42.125L.831 39.142h1.972l1.108 1.644 1.095-1.644h1.911l-2.069 2.946 2.325 3.347H5.201l-1.315-1.984-1.314 1.984H.636z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 247",
    d: "M15.364 41.71H9.217v-1.3h6.147zm0 2.605H9.217v-1.3h6.147z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 248",
    d: "M20.074 38.169h-1.728v-1.422h1.728zm-1.728.973h1.728v6.293h-1.728z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 249",
    d: "M21.193 39.141h1.644v.876h.036a2.246 2.246 0 011.923-1.047c1.838 0 2.3 1.035 2.3 2.593v3.87h-1.729v-3.554c0-1.034-.3-1.545-1.108-1.545-.937 0-1.339.523-1.339 1.8v3.3h-1.729z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 250",
    d: "M32.659 44.632h-.024a2.09 2.09 0 01-1.911.973c-1.9 0-2.824-1.631-2.824-3.372 0-1.692.937-3.262 2.788-3.262a2.2 2.2 0 011.874.938h.012v-3.162h1.729v8.691h-1.644zm-1.509-4.358c-1.133 0-1.522.973-1.522 2.008 0 .986.451 2.021 1.522 2.021 1.144 0 1.485-1 1.485-2.033s-.365-1.996-1.485-1.996z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 251",
    d: "M36.786 42.709c.048 1.095.584 1.594 1.545 1.594a1.421 1.421 0 001.363-.816h1.522a2.832 2.832 0 01-2.946 2.118 3.073 3.073 0 01-3.213-3.31 3.156 3.156 0 013.21-3.321c2.143 0 3.177 1.8 3.055 3.738zm2.812-1.1c-.159-.876-.535-1.339-1.376-1.339a1.361 1.361 0 00-1.436 1.339z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 252",
    d: "M42.104 39.141h1.644v.8h.024a2.1 2.1 0 011.874-.974c1.972 0 2.86 1.6 2.86 3.384 0 1.68-.925 3.25-2.763 3.25a2.233 2.233 0 01-1.887-.949h-.024v2.994h-1.729zm4.674 3.165c0-1-.4-2.033-1.509-2.033-1.133 0-1.5 1.01-1.5 2.033s.39 2 1.51 2 1.499-.977 1.499-1.999z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 253",
    d: "M50.722 42.709c.049 1.095.584 1.594 1.546 1.594a1.421 1.421 0 001.363-.816h1.521a2.831 2.831 0 01-2.945 2.118 3.073 3.073 0 01-3.213-3.31 3.156 3.156 0 013.213-3.324c2.143 0 3.177 1.8 3.055 3.738zm2.813-1.1c-.159-.876-.536-1.339-1.376-1.339a1.362 1.362 0 00-1.437 1.339z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 254",
    d: "M56.041 39.141h1.643v.876h.037a2.244 2.244 0 011.923-1.047c1.838 0 2.3 1.035 2.3 2.593v3.87h-1.728v-3.554c0-1.034-.3-1.545-1.108-1.545-.937 0-1.339.523-1.339 1.8v3.3H56.04z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 255",
    d: "M67.507 44.632h-.024a2.09 2.09 0 01-1.911.973c-1.9 0-2.824-1.631-2.824-3.372 0-1.692.938-3.262 2.788-3.262a2.2 2.2 0 011.874.938h.013v-3.162h1.728v8.691h-1.643zm-1.51-4.358c-1.132 0-1.521.973-1.521 2.008 0 .986.451 2.021 1.521 2.021 1.145 0 1.485-1 1.485-2.033s-.365-1.996-1.485-1.996z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 256",
    d: "M71.632 42.709c.049 1.095.584 1.594 1.546 1.594a1.422 1.422 0 001.363-.816h1.521a2.831 2.831 0 01-2.945 2.118 3.073 3.073 0 01-3.213-3.31 3.156 3.156 0 013.213-3.324c2.142 0 3.177 1.8 3.055 3.738zm2.812-1.1c-.158-.876-.535-1.339-1.375-1.339a1.362 1.362 0 00-1.437 1.339z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 257",
    d: "M76.951 39.141h1.643v.876h.037a2.244 2.244 0 011.927-1.043c1.838 0 2.3 1.035 2.3 2.593v3.87h-1.729v-3.554c0-1.034-.3-1.545-1.107-1.545-.938 0-1.339.523-1.339 1.8v3.3h-1.729z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 258",
    d: "M86.116 39.141h1.266v1.157h-1.266v3.117c0 .584.146.73.731.73a2.631 2.631 0 00.535-.049v1.352a6.709 6.709 0 01-1.01.061c-1.059 0-1.984-.244-1.984-1.5v-3.713h-1.047v-1.155h1.048v-1.886h1.728z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 259",
    d: "M88.014 36.747h1.729v8.691h-1.729z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 260",
    d: "M93.967 46.227a1.974 1.974 0 01-2.167 1.419 10.194 10.194 0 01-1.059-.061v-1.419a9.3 9.3 0 001.01.061.815.815 0 00.6-1.181l-2.215-5.9h1.85l1.425 4.309h.024l1.376-4.309h1.79z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 261",
    d: "M103.132 38.974a3.318 3.318 0 11-3.25 3.324 3.09 3.09 0 013.25-3.324zm0 5.332c1.181 0 1.533-1.01 1.533-2.008s-.353-2.021-1.533-2.021-1.521 1.01-1.521 2.021.353 2.005 1.521 2.005z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 262",
    d: "M107.027 39.141h1.643v1.169h.025a2.225 2.225 0 012.008-1.339 1.281 1.281 0 01.378.062v1.606a3.13 3.13 0 00-.621-.061c-1.266 0-1.7.913-1.7 2.021v2.836h-1.733z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 263",
    d: "M117.567 45.033c0 1.035-.365 2.788-3.261 2.788-1.242 0-2.691-.584-2.776-2.02h1.716a1.17 1.17 0 001.29.864c.962 0 1.4-.658 1.388-1.558v-.833h-.024a2.127 2.127 0 01-1.887.974c-1.886 0-2.69-1.436-2.69-3.165 0-1.631.937-3.117 2.7-3.117a1.958 1.958 0 011.874 1.011h.024v-.84h1.643zm-1.643-2.824c0-1.023-.353-1.935-1.473-1.935-.974 0-1.4.852-1.4 1.79 0 .9.341 1.886 1.4 1.886a1.549 1.549 0 001.473-1.741z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 264",
    d: "M118.394 41.074c.1-1.619 1.546-2.107 2.958-2.107 1.253 0 2.763.28 2.763 1.79v3.274a3.218 3.218 0 00.219 1.4h-1.753a2.565 2.565 0 01-.122-.608 2.886 2.886 0 01-2.119.779c-1.193 0-2.142-.6-2.142-1.886 0-1.424 1.071-1.765 2.142-1.911s2.046-.122 2.046-.828c0-.743-.511-.852-1.121-.852-.657 0-1.083.268-1.144.95zm3.993 1.277a3.436 3.436 0 01-1.437.366c-.535.11-1.023.292-1.023.925s.5.8 1.06.8a1.284 1.284 0 001.4-1.448z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 265",
    d: "M125.211 39.141h1.644v.876h.036a2.246 2.246 0 011.923-1.047c1.838 0 2.3 1.035 2.3 2.593v3.87h-1.729v-3.554c0-1.034-.3-1.545-1.108-1.545-.937 0-1.339.523-1.339 1.8v3.3h-1.729z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 266",
    d: "M133.719 38.169h-1.729v-1.422h1.729zm-1.729.973h1.729v6.293h-1.729z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 267",
    d: "M134.449 44.133l3.274-3.688h-3.031v-1.3h5.307v1.3l-3.274 3.688h3.506v1.3h-5.782z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 268",
    d: "M142.337 42.709c.049 1.095.584 1.594 1.545 1.594a1.423 1.423 0 001.364-.816h1.521a2.832 2.832 0 01-2.946 2.118 3.073 3.073 0 01-3.213-3.31 3.157 3.157 0 013.213-3.324c2.143 0 3.177 1.8 3.056 3.738zm2.812-1.1c-.158-.876-.535-1.339-1.376-1.339a1.361 1.361 0 00-1.436 1.339z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 269",
    d: "M152.148 44.632h-.025a2.09 2.09 0 01-1.91.973c-1.9 0-2.824-1.631-2.824-3.372 0-1.692.937-3.262 2.788-3.262a2.2 2.2 0 011.875.938h.012v-3.162h1.729v8.691h-1.643zm-1.509-4.358c-1.133 0-1.521.973-1.521 2.008 0 .986.45 2.021 1.521 2.021 1.144 0 1.485-1 1.485-2.033s-.366-1.996-1.486-1.996z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 270",
    d: "M160.094 38.347h-2.6v-1.6h7.121v1.6h-2.605v7.084h-1.916z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 271",
    d: "M165.367 36.747h6.5v1.6h-4.588v1.862h4.211v1.485h-4.211v2.131h4.688v1.606h-6.6z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 272",
    d: "M172.765 36.747h3.75c2.251 0 3.943 1.413 3.943 4.3 0 2.519-1.29 4.394-3.943 4.394h-3.75zm1.911 7.085h1.7c1.108 0 2.167-.682 2.167-2.605 0-1.753-.609-2.873-2.508-2.873h-1.363z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 273",
    d: "M185.923 42.709c.049 1.095.584 1.594 1.545 1.594a1.423 1.423 0 001.364-.816h1.521a2.831 2.831 0 01-2.946 2.118 3.073 3.073 0 01-3.213-3.31 3.157 3.157 0 013.213-3.324c2.143 0 3.177 1.8 3.056 3.738zm2.812-1.1c-.158-.876-.535-1.339-1.375-1.339a1.362 1.362 0 00-1.437 1.339z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 274",
    d: "M194.478 45.435h-1.923l-2.155-6.293h1.814l1.327 4.3h.025l1.326-4.3h1.717z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 275",
    d: "M198.265 42.709c.049 1.095.584 1.594 1.545 1.594a1.423 1.423 0 001.364-.816h1.521a2.832 2.832 0 01-2.946 2.118 3.073 3.073 0 01-3.213-3.31 3.157 3.157 0 013.216-3.321c2.143 0 3.177 1.8 3.055 3.738zm2.812-1.1c-.159-.876-.535-1.339-1.376-1.339a1.361 1.361 0 00-1.436 1.339z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 276",
    d: "M203.584 39.141h1.643v.876h.036a2.246 2.246 0 011.923-1.047c1.838 0 2.3 1.035 2.3 2.593v3.87h-1.729v-3.554c0-1.034-.3-1.545-1.108-1.545-.937 0-1.339.523-1.339 1.8v3.3h-1.728z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 277",
    d: "M212.749 39.141h1.266v1.157h-1.266v3.117c0 .584.146.73.731.73a2.631 2.631 0 00.535-.049v1.352a6.72 6.72 0 01-1.011.061c-1.059 0-1.984-.244-1.984-1.5v-3.713h-1.047v-1.155h1.047v-1.886h1.729z",
    fill: "#828896"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 41"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 38",
    fill: "#828896"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 278",
    d: "M8.11 7.99H0V.573h25.132V7.99h-8.108v21.521H8.115z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 279",
    d: "M26.512.573h24.392V7.99H35.428v3.608h15.476v6.893H35.428v3.607h15.479v7.417h-24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 280",
    d: "M52.404.573h14.631C76.68.573 80.088 7.707 80.088 15c0 8.879-4.7 14.512-14.794 14.512h-12.89zm8.915 21.525h3.487c5.554 0 6.366-4.5 6.366-7.218 0-1.82-.571-6.886-7.015-6.886H61.32z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 40"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 39"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 281",
    d: "M92.899 18.36l-2.72-4.51-2.652 4.51h-6.532l6.2-9.119L81.223.517h6.535l2.42 4.313 2.49-4.312h6.533l-5.97 8.724 6.2 9.119z",
    fill: "#828896"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 42",
    fill: "#828896"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 282",
    d: "M106.216.648h5.593l8.286 24.364L128.323.648h5.553v28.816h-3.727V12.457q0-.883.039-2.923t.039-4.375l-8.228 24.3h-3.868l-8.305-24.3v.883q0 1.059.059 3.227t.058 3.188v17.007h-3.727z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 283",
    d: "M150.569 16.75a1.919 1.919 0 001.629-1.019 3.127 3.127 0 00.235-1.359 2.886 2.886 0 00-1.282-2.629 6.855 6.855 0 00-3.67-.816 4.651 4.651 0 00-3.916 1.5 4.951 4.951 0 00-.841 2.465h-3.3q.1-3.895 2.517-5.419a10.306 10.306 0 015.614-1.525 11.415 11.415 0 016.016 1.413 4.8 4.8 0 012.292 4.394v12.1a1.544 1.544 0 00.225.882 1.086 1.086 0 00.952.333c.157 0 .333-.01.529-.029s.405-.049.627-.088v2.612a9.9 9.9 0 01-1.255.295 9.335 9.335 0 01-1.177.058 2.9 2.9 0 01-2.648-1.294 4.984 4.984 0 01-.608-1.941 8.989 8.989 0 01-3.1 2.452 9.6 9.6 0 01-4.453 1.039 6.626 6.626 0 01-4.777-1.773 5.886 5.886 0 01-1.854-4.438 5.709 5.709 0 011.825-4.525 8.681 8.681 0 014.786-1.98zm-7.435 9.539a4.154 4.154 0 002.649.88 8.069 8.069 0 003.609-.861 4.85 4.85 0 002.943-4.681v-2.84a6.051 6.051 0 01-1.664.689 14.048 14.048 0 01-2 .392l-2.134.275a8.257 8.257 0 00-2.885.8 3.122 3.122 0 00-1.638 2.937 2.9 2.9 0 001.12 2.409z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 284",
    d: "M165.183 8.455v13.948a6.005 6.005 0 00.5 2.628 3.448 3.448 0 003.42 1.884 4.835 4.835 0 004.891-3.3 13.4 13.4 0 00.707-4.845V8.455h3.531v21.009h-3.335l.039-3.1a7.1 7.1 0 01-1.676 2.02 7.276 7.276 0 01-4.812 1.647q-4.408 0-6.005-3a9.081 9.081 0 01-.866-4.3V8.455z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 285",
    d: "M195.256 16.75a1.92 1.92 0 001.629-1.019 3.126 3.126 0 00.235-1.359 2.885 2.885 0 00-1.282-2.629 6.855 6.855 0 00-3.67-.816 4.65 4.65 0 00-3.916 1.5 4.959 4.959 0 00-.842 2.465h-3.3q.1-3.895 2.518-5.419a10.3 10.3 0 015.614-1.525 11.41 11.41 0 016.015 1.413 4.794 4.794 0 012.293 4.394v12.1a1.544 1.544 0 00.225.882 1.085 1.085 0 00.951.333c.157 0 .333-.01.53-.029s.4-.049.627-.088v2.609a9.939 9.939 0 01-1.255.295 9.333 9.333 0 01-1.177.058 2.9 2.9 0 01-2.648-1.294 4.967 4.967 0 01-.608-1.941 8.99 8.99 0 01-3.1 2.452 9.6 9.6 0 01-4.453 1.039 6.626 6.626 0 01-4.777-1.773 5.883 5.883 0 01-1.854-4.438 5.709 5.709 0 011.825-4.525 8.681 8.681 0 014.786-1.98zm-7.435 9.539a4.154 4.154 0 002.649.88 8.069 8.069 0 003.609-.861 4.85 4.85 0 002.943-4.681v-2.84a6.064 6.064 0 01-1.665.689 14.042 14.042 0 01-2 .392l-2.134.275a8.253 8.253 0 00-2.885.8 3.122 3.122 0 00-1.638 2.937 2.9 2.9 0 001.121 2.409zM196.747 0l-5.238 5.669h-2.707L192.391 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTedxMau);
export default __webpack_public_path__ + "static/media/tedxMauá.ee0eedd3c2543620344ba930fdd0cf03.svg";
export { ForwardRef as ReactComponent };